import React, { useEffect } from 'react';
import { FaExclamationCircle, FaTimes } from 'react-icons/fa';

interface CatalogueNoticeProps {
  showModal: boolean;
  setShowErrorModal: (value: boolean) => void;
}

const CatalogueNotice: React.FC<CatalogueNoticeProps> = ({ showModal, setShowErrorModal }) => {
  useEffect(() => {
    if (!showModal) {
      return undefined;
    }

    const timeout = window.setTimeout(() => {
      setShowErrorModal(false);
    }, 3200);

    return () => window.clearTimeout(timeout);
  }, [showModal, setShowErrorModal]);

  if (!showModal) {
    return null;
  }

  return (
    <div className="tw-fixed tw-right-6 tw-top-6 tw-z-[95] tw-w-full tw-max-w-md">
      <div className="tw-flex tw-items-start tw-gap-3 tw-rounded-2xl tw-border tw-border-amber-200 tw-bg-white/95 tw-p-4 tw-shadow-[0_20px_50px_rgba(15,23,42,0.18)] tw-backdrop-blur">
        <div className="tw-mt-0.5 tw-text-amber-500">
          <FaExclamationCircle />
        </div>
        <div className="tw-min-w-0 tw-flex-1">
          <p className="tw-text-sm tw-font-semibold tw-text-slate-900">No data found</p>
          <p className="tw-mt-1 tw-text-sm tw-text-slate-600">
            No catalog data was found for that selection.
          </p>
        </div>
        <button
          className="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-xl tw-text-slate-400 tw-transition hover:tw-bg-slate-100 hover:tw-text-slate-600"
          onClick={() => setShowErrorModal(false)}
          aria-label="Dismiss notice"
        >
          <FaTimes />
        </button>
      </div>
    </div>
  );
};

export default CatalogueNotice;
